<template>
  <div>
    <!-- <pre>{{clientsListInvoices}}</pre> -->
    <vx-card title="Search View" class="mb-4">
      <div class="filter-holder">
        <div class="p-1 filter-holder-col">
          <vs-input
            placeholder="Search"
            class="w-full"
            v-model="search"
            @keyup="searchFun"
            style="width: 100%"
          />
        </div>
        <div class="p-1 filter-holder-col">
          <v-select
            placeholder="Filter Course"
            appendToBody
            v-model="filterPayload.course_id"
            :options="courseOpt"
            :reduce="course => course.id"
            label="name"
            :clearable="false"
            @open="onOpen"
            @close="onClose"
          >
            <template #list-footer>
              <li ref="load" class="loader" v-show="course_list_meta.has_next">
                Loading more courses...
              </li>
            </template>
          </v-select>
        </div>
        <div class="p-1 filter-holder-col">
          <v-select
            placeholder="Filter Payment"
            appendToBody
            v-model="filterPayload.payment_mode"
            :options="paymentOpt"
            :reduce="mode => mode.value"
            label="label"
            :clearable="false"
          ></v-select>
        </div>
        <div class="p-1 filter-holder-col">
          <date-range-picker
            ref="picker"
            class="w-full"
            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
            :showWeekNumbers="true"
            :showDropdowns="true"
            :autoApply="true"
            :ranges="customDateRanges()"
            v-model="dateRange"
          >
            <template v-slot:input="picker" style="min-width: 350px">
              <span
                v-if="
                  dateRange.startDate === null || dateRange.endDate === null
                "
                style="
                  color: rgba(0, 0, 0, 0.5);
                  font-weight: 400;
                  font-size: 12px;
                "
                >Select Date Range</span
              >
              <span v-else
                >{{ picker.startDate | date }} -
                {{ picker.endDate | date }}</span
              >
            </template>
          </date-range-picker>
        </div>
        <div class="p-1 filter-holder-col">
          <v-select
            placeholder="Filter Status"
            appendToBody
            class="w-full"
            v-model="filterPayload.payment_status"
            :options="statusOpt"
            :reduce="status => status.value"
            label="label"
            :clearable="false"
          ></v-select>
        </div>
        <div class="p-1 flex">
          <vs-button @click="runFilter" class="includeIcon includeIconOnly"
            >Go</vs-button
          >

          <vs-tooltip text="Reset">
            <vs-button
              @click="resetFilter"
              type="border"
              icon-pack="feather"
              icon="icon-refresh-ccw"
              class="ml-2"
            ></vs-button>
          </vs-tooltip>
        </div>
      </div>
    </vx-card>

    <ag-grid-vue
      ref="agGridTable"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :style="{ minHeight: meta.limit * 48 + 75 + 'px' }"
      :gridOptions="gridOptions"
      :animateRows="true"
      :floatingFilter="false"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="clientsListInvoices"
      @grid-ready="onGridReady"
      @sortChanged="sortFun"
    />

    <div class="sm:flex justify-between items-center">
      <ItemsPerTableDropdown
        tableName="student_finance_list"
        @change="pageLimit => (pageLimitSet = pageLimit)"
      />

      <pagination
        :meta="meta"
        v-if="clientsListInvoices.length !== 0"
        @page-change="handlePageChange"
        class="ml-auto"
      />
    </div>

    <!-- <div class="filter-holder">
              <div class="p-1 filter-holder-col">
                <v-select placeholder="Filter Course" :options="courseOpt" label="text"></v-select>
              </div>
              <div class="p-1 filter-holder-col">
                <v-select placeholder="Filter Payment" :options="paymentOpt" label="text"></v-select>
              </div>
              <div class="p-1 filter-holder-col"> 
                 <date-range-picker
        ref="picker"
                          class="w-full"

        :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
        :showWeekNumbers="true"
        :showDropdowns="true"
        :autoApply="true"
        v-model="dateRange"
      >
        <template v-slot:input="picker" style="min-width: 350px">
          {{ picker.startDate | date }} - {{ picker.endDate | date }}
        </template>
      </date-range-picker>
              </div>
              <div class="p-1 filter-holder-col">
                <v-select placeholder="Filter Status" class="w-full" :options="statusOpt" label="text"></v-select>
              </div>
              <div class="p-1 filter-holder-col">
                <vs-button class="w-full">Search</vs-button>
              </div>
            </div> -->
  </div>
</template>

<script>
import { FinanceMixin } from '../mixins/FinanceMixin'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vSelect from 'vue-select'
import moment from 'moment'
import Pagination from '@/components/common/pagination'
import { AgGridVue } from 'ag-grid-vue'
import FullNameCell from './student_finance_table_cells/FullNameCell.vue'
import InvoiceNumberCell from './student_finance_table_cells/InvoiceNumberCell.vue'
import AmountCell from './student_finance_table_cells/AmountCell.vue'
import StatusCell from './student_finance_table_cells/StatusCell.vue'
import { courseListing } from '@/api/course-builderapi'
import {
  getPaymentModeList,
  getPaymentStatusList,
  fetchStudentFinanceBySearch
} from '@/api/finance'

export default {
  mixins: [FinanceMixin],
  components: {
    DateRangePicker,
    vSelect,
    Pagination,
    AgGridVue,
    FullNameCell,
    InvoiceNumberCell,
    AmountCell,
    StatusCell
  },
  created () {
    //this.checkingQuery('/pages/finance')
    this.customer_id = localStorage.getItem('customer_id')

    // if (this.quickBook === true) {
    //   this.quickbooksFetch(1)
    // } else {
    //this.fetchCLientFinance(1, this.meta.limit)
    //}

    this.getCourseOptions()
    this.getPaymentModeOptions()
    this.getPaymentStatusOptions()
  },
  data () {
    return {
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      gridOptions: {
        accentedSort: true
      },
      gridApi: null,
      search: '',
      currency_code:JSON.parse(localStorage.getItem('localization'))
        .currency.currency_symbol,
      customer_id: null,
      columnDefs: [
        {
          headerName: 'Full Name',
          field: 'fullname',
          cellRendererFramework: 'FullNameCell'
        },
        {
          headerName: 'Invoice #',
          field: 'invoice_number',
          cellRendererFramework: 'InvoiceNumberCell',
          CellRendererParams: {
            openSideBar: data => this.openSideBar(data)
          }
        },
        {
          headerName: 'Course',
          field: 'course_name'
        },
        {
          headerName: 'Type of Payment',
          field: 'payment_mode'
        },
        {
          headerName: 'Amount',
          field: 'amount',
          cellRendererFramework: 'AmountCell',
          comparator:(value)=> {}
        },
        {
          headerName: 'Status',
          minWidth: 150,
          maxWidth: 150,
          field: 'status',
          sortable: false,
          cellRendererFramework: 'StatusCell'
        }
      ],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 5,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1
      },
      pageLimitSet: null,
      courseOpt: [],
      paymentOpt: [],
      statusOpt: [],
      dateRange: { startDate: null, endDate: null },
      dateRange1: {},
      filterPayload: {
        course_id: null,
        payment_mode: null,
        payment_status: null
      },
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      observer: new IntersectionObserver(this.loadMoreCourses)
    }
  },
  mounted () {
    //console.log(this.gridOptions)
    //this.gridApi = this.gridOptions.api
  },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  methods: {
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId == 'invoice_number') {
        field_name = 'id'
      }
      return field_name
    },
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()

        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          this.sorting_obj.direction = sortState[0].sort

          this.fetchInvoiceListBySearch()
        }
      } catch (e) {}
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async vm => {
      try {
        const payload = {
          search: vm.search,
          customer_id: vm.$store.getters.customerId
        }

        const responseData = await fetchStudentFinanceBySearch(payload)
        vm.clientsListInvoices = responseData.data.data.invoices
        vm.schoolAddress = responseData.data.data.address
        vm.platformCustomerInfo = responseData.data.data.platform_customer
        vm.meta = responseData.data.data.meta
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    paginationPageSize () {
      return this.pageLimitSet
    },
    openSideBar (data) {
      this.$emit(
        'listenOpenSidebar',
        data,
        this.schoolAddress,
        this.platformCustomerInfo
      )
    },
    handlePageChange (page) {
      if (!this.pageLimitSet) return
      // console.log(this.quickBook)
      this.meta.current_page = page
      this.meta.limit = this.pageLimitSet

      const payload = {
        ...this.filterPayload,
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate
      }
      /* const pageScroll = document.documentElement.scrollTop
      this.$router.replace({
        path:'/pages/finance',
        query:{page:this.meta.current_page}
      }).catch(() => {}).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
      // this.$router.replace({ path: '/pages/leads', query: queryPayload })
      // if (this.quickBook === true) {
      //   this.quickbooksFetch(page);
      // } else {
      if (this.search !== '' || this.sorting_obj.attribute != '') {
        this.fetchInvoiceListBySearch()
      } else if (this.search == '') {
        this.fetchCLientFinance(page, this.meta.limit, payload)
      } else {
        this.fetchCLientFinance()
      }

      // }
    },
    async fetchInvoiceListBySearch () {
      try {
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId
        }

        const responseData = await fetchStudentFinanceBySearch(
          payload,
          this.meta.current_page,
          this.pageLimitSet,
          this.sorting_obj
        )
        this.clientsListInvoices = responseData.data.data.invoices
        this.schoolAddress = responseData.data.data.address
        this.platformCustomerInfo = responseData.data.data.platform_customer
        this.meta = responseData.data.data.meta
      } catch (e) {}
    },
    genInvoice (id) {
      this.$router.push({
        name: 'invoice-preview',
        params: {
          invoiceSidebarData: id
        }
      })
    },
    async getCourseOptions () {
      try {
        const response = await courseListing(this.customer_id)
        this.courseOpt = response.data.data.courselist
        this.course_list_meta = response.data.data.meta
      } catch (e) {}
    },
    async getPaymentModeOptions () {
      try {
        const response = await getPaymentModeList(this.customer_id)
        this.paymentOpt = response.data.data.payment_mode_list
      } catch (e) {}
    },
    async getPaymentStatusOptions () {
      try {
        const response = await getPaymentStatusList(this.customer_id)
        this.statusOpt = response.data.data.payment_status_list
      } catch (e) {}
    },
    async runFilter () {
      const payload = {
        ...this.filterPayload,
        startDate: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.dateRange.endDate).format('YYYY-MM-DD')
      }
      if (
        this.dateRange.startDate === null ||
        this.dateRange.endDate === null
      ) {
        payload.startDate = null
        payload.endDate = null
      }

      await this.fetchCLientFinance(
        this.meta.current_page,
        this.meta.limit,
        payload
      )
    },
    async resetFilter () {
      this.search = null
      this.filterPayload = {
        course_id: null,
        payment_mode: null,
        payment_status: null
      }

      this.dateRange = { startDate: null, endDate: null }

      await this.fetchCLientFinance(this.meta.current_page, this.meta.limit)
    },
    async onOpen () {
      if (this.course_list_meta.has_next) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    async loadMoreCourses ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const response = await courseListing(
            this.customer_id,
            undefined,
            this.course_list_meta.current_page + 1
          )
          this.courseOpt.push(...response.data.data.courselist)

          this.course_list_meta = response.data.data.meta
        } catch (e) {}

        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  }
}
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
